//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// Not Found Page - Notifies the user that they attempted to access a page that
// could not be found.
//

// Libs
import React from 'react';
import PropTypes from 'prop-types';
import {
    FlexLayout,
    StackingLayout,
    NutanixLogo,
    Link,
    Separator,
    VerticalSeparator,
} from '@nutanix-ui/prism-reactjs';
import getI18nService from '../../i18n/I18n';

import './LoginFooter.less';

const i18n = getI18nService();

export default class LoginFooter extends React.PureComponent {
    static propTypes = {
        text: PropTypes.string,
    };

    render() {
        const { text = '' } = this.props;
        return (
            <FlexLayout
                className="LoginFooter"
                itemSpacing="0px"
                alignItems="center"
                justifyContent="center"
            >
                <StackingLayout>
                    <FlexLayout alignItems="center" justifyContent="center">
                        <NutanixLogo color="light-gray" />
                    </FlexLayout>
                    <FlexLayout alignItems="center" role="links">
                        <Separator
                            separator={<VerticalSeparator size="large" />}
                            spacing="spacing-20px"
                        >
                            {text}
                            <Link aria-label="link-customers">
                                {i18n.t('Vocabulary.Customers')}
                            </Link>
                            <Link aria-label="link-partners">{i18n.t('Vocabulary.Partners')}</Link>
                            <Link aria-label="link-education">
                                {i18n.t('Vocabulary.Education')}
                            </Link>
                            <Link aria-label="link-support">{i18n.t('Vocabulary.Support')}</Link>
                        </Separator>
                    </FlexLayout>
                </StackingLayout>
            </FlexLayout>
        );
    }
}
